import './App.css';
import './style/css/reset.css'
import './style/css/sidebar.css'
import './style/css/style.css'
import './style/css/zone.css'
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './Pages/Login';
import MainPage from './Pages/MainPage';
import Filter from './Pages/Filter';
import LeaderBoard from './Pages/LeaderBoard';
import TeamLeaderBoard from './Pages/TeamLeaderBoard';
import Roster from './Pages/Roster';
import PersonBatter from './Pages/PersonBatter';
import PersonPitcher from './Pages/PersonPitcher';
import { useEffect } from 'react';
import { PitchReport } from './Pages/PitcherReport';
import jwtDecode from 'jwt-decode';
import { ProtectedRoute } from './Components/ProtectedRoute';
import { PAReport } from './Pages/PAReport';
import { TeamsMainPage } from './Pages/TeamsMainPage';
import { Video } from './Pages/Video';

export const OpenindDayDate = new Date(2022, 3, 3)

const App = () => {
  const handleGoogleCallbaclResponse = (response) => {
    console.log(jwtDecode(response.credential))
    console.log("Successfully get Google login info!")
  }

  /* Not ready for google login
  useEffect(() => {
    // /* global google (back star need to be added when use)
    google.accounts.id.initialize({
      client_id: process.env.REACT_APP_GOOGLE_TEST_API_CLIENT_ID,
      callback: handleGoogleCallbaclResponse
    })
    // console.log(google.accounts.id)
    google.accounts.id.renderButton(document.getElementById('google-login-btn'), {theme: 'filled_blue', size: 'large', shape: 'pill', width: 210, text: 'signin_with'})
  });
  */

  return (
    <div className="App">
      <Routes>
        <Route path='/filter' element={<ProtectedRoute element={<Filter />} />} />
        <Route path='/video' element={<ProtectedRoute element={<Video />} />} />
        {/* <Route path='/leaderboard' element={<ProtectedRoute element={<LeaderBoard />} />} />
        <Route path='/team-leaderboard' element={<ProtectedRoute element={<TeamLeaderBoard />} />} />
        <Route path='/roster' element={<ProtectedRoute element={<Roster />} />} />
        <Route path='/batter/:team/:number' element={<ProtectedRoute element={<PersonBatter />} />} />
        <Route path='/pitcher/:team/:number' element={<ProtectedRoute element={<PersonPitcher />} />} />
        <Route path='/teams' element={<ProtectedRoute element={<TeamsMainPage />} />} /> */}
        <Route path='/login' element={<Login />} />
        <Route path='*' element={<Navigate to='/filter' replace />} />
        {/*<Route path='/report' element={<PAReport />} />*/}
        {/*<Route path='/pitchreport' element={<PitchReport />} />*/}
        {/* Temperorily block all other routes for filter load test*/}
        {/*<Route path='/main' element={<MainPage />} />*/}
      </Routes>
    </div>
  );
}

export default App;
